import { useSearchParams } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
const useContactSearchParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useMemo(() => ({
        q: searchParams.get('q') || '',
        is_demo: searchParams.get('is_demo') === 'true' ? true : undefined,
        offset: Math.max(0, Math.floor(Number(searchParams.get('offset')) || 0)),
        limit: Math.max(1, Math.floor(Number(searchParams.get('limit')) || 20))
    }), [searchParams]);
    const setQuery = useCallback((q) => {
        setSearchParams((prev) => {
            if (q) {
                prev.set('q', q);
            }
            else {
                prev.delete('q');
            }
            prev.delete('offset');
            return prev;
        });
    }, [setSearchParams]);
    const setIsDemo = useCallback((isDemo) => {
        setSearchParams((prev) => {
            if (isDemo) {
                prev.set('is_demo', 'true');
            }
            else {
                prev.delete('is_demo');
            }
            prev.delete('offset');
            return prev;
        });
    }, [setSearchParams]);
    const setOffset = useCallback((offset) => {
        setSearchParams((prev) => {
            prev.set('offset', String(offset));
            return prev;
        });
    }, [setSearchParams]);
    return { params, setQuery, setIsDemo, setOffset };
};
export default useContactSearchParams;
